export default "__VITE_ASSET__BtXebMK1__"